export default "__VITE_ASSET__CXLa9LVU__"